/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type AnsweredCommentContainer_viewer = {
    readonly id: string;
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly ignoredUsers: ReadonlyArray<{
        readonly id: string;
    }>;
    readonly role: USER_ROLE;
    readonly mediaSettings: {
        readonly unfurlEmbeds: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"UsernameWithPopoverContainer_viewer" | "ReactionButtonContainer_viewer" | "CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "AnsweredCommentContainer_viewer";
};
export type AnsweredCommentContainer_viewer$data = AnsweredCommentContainer_viewer;
export type AnsweredCommentContainer_viewer$key = {
    readonly " $data"?: AnsweredCommentContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentContainer_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AnsweredCommentContainer_viewer",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "UserStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "current",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "ignoredUsers",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserMediaSettings",
                "kind": "LinkedField",
                "name": "mediaSettings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unfurlEmbeds",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CommentContainer_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IgnoredTombstoneOrHideContainer_viewer"
            }
        ],
        "type": "User",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'f43166d0b1bdc49925e45e5f1e4ad63e';
export default node;
